import _ from 'lodash'
import Push from 'push.js'
import router from '../router'
var _defaultTimeout = 6000

export const _Notifier = {
  namespaced: true,
  state: {
    notifications: [],
    show: false
  },
  getters: {
    /**
     * Retourne l'index de la première notification non vu
     */
    index (state) {
      return state.notifications.findIndex(o => !o.vu || o.vu === false)
    },
    /**
     * Retourne le tableau des notifications persistentes
     */
    notifsPersistantes (state) {
      console.log('notif :', state.notifications.filter(o => o.type))
      return state.notifications.filter(o => o.type)
    }
  },
  mutations: {
    INIT (state) {
      state.notifications = []
      state.show = false
    },
    /**
     * Ajoute une notification dans le tableau des notifs gérées par ce store
     * @param {Object} notif  notification à ajouter
     */
    ADD_NOTIF (state, notif) {
      state.notifications.push(notif)
    },
    /**
     * Met à jour une notification (notamment dans le cas d'un nouveau message d'un visiteur)
     */
    UPDATE_NOTIF (state, notif) {
      state.notifications.splice(notif.idxVisfound, 1, notif)
    },
    /**
     * Supprime la plus vieille notification
     */
    REMOVE_NOTIF (state, index) {
      if (index !== -1 && state.notifications[index]) {
        // Suppression de la notif globale
        if (state.notifications[index].data && state.notifications[index].data.titre) {
          Push.close(state.notifications[index].data.titre)
        }
        window.clearTimeout(state.notifications[index].timeout)
        state.notifications.splice(index, 1)
      }
    },
    /**
     * Supprime toutes les notifications qui ne sont pas persistentes
     */
    CLEAR (state) {
      if (state.notifications) {
        let notifications = []
        state.notifications.forEach((notif, key) => {
          window.clearTimeout(notif.timeout)
          if (notif.type) {
            notifications.push(notif)
          }
        })
        state.notifications = _.cloneDeep(notifications)
        state.show = false
      }
    },
    /**
     * Supprime toutes les notifications
     */
    CLEAR_ALL (state) {
      state.notifications = []
      state.show = false
    },
    /**
     * Affiche la notification
     */
    SHOW (state) {
      state.show = true
    },
    /**
     * Cache la notification
     */
    HIDE (state) {
      state.show = false
    },
    /**
     * Indique que la notification a été vue
     * @param {Integer} index la notification à marquer comme étant vue
     */
    VU (state, index) {
      state.notifications[index].vu = true
    }
  },
  actions: {
    NEW_NOTIF ({ commit, state }, notif) {
      // console.log('notif', notif)
      // timeout de la notification
      notif.timeout = notif.timeout || _defaultTimeout
      // action de la notification
      notif.action = notif.action || { text: 'Fermer', path: null }
      // nombre de fois que le visiteur a envoyé des messages non lus
      notif.count = 1
      // indice de la notification du visiteur ayant déjà envoyé un message non lu (le cas échéant)
      let idxVisfound = -1
      // si la notification est un message classic
      if (notif.type === 'message') {
        notif.action = {text: 'Répondre', path: '/trafic/chatting'}
        idxVisfound = state.notifications.findIndex(o => {
          if (o.data && notif.data.titre) {
            return o.data.titre === notif.data.titre
          }
        })
        // visiteur a déjà envoyé un message non lu
        if (idxVisfound !== -1) {
          notif.count = state.notifications[idxVisfound].count + 1
        }
      // si la notification de quota
      } else if (notif.type === 'collections') {
        // pas de path pour les notifications quota
        notif.action = {text: 'Fermer'}
        idxVisfound = state.notifications.findIndex(o => {
          if (o.data && notif.data.titre) {
            return o.data.titre === notif.data.titre
          }
        })
        // Si il y a déjà une notification non lu
        if (idxVisfound !== -1) {
          notif.count = state.notifications[idxVisfound].count + 1
        }
      // si la notification de Click to call
      } else if (notif.type === 'phone_in_talk') {
        // pas de path pour les notifications quota
        notif.action = {text: 'Fermer'}
        idxVisfound = state.notifications.findIndex(o => {
          if (o.data && notif.data.titre) {
            return o.data.titre === notif.data.titre
          }
        })
        // Si il y a déjà une notification non lu
        if (idxVisfound !== -1) {
          notif.count = state.notifications[idxVisfound].count + 1
        }
        // notification licence coupée quota 100 % de pages traquées
      } else if (notif.type === 'error') {
        // pas de path pour les notifications quota
        notif.action = {text: 'Fermer', path: notif.url}
        idxVisfound = state.notifications.findIndex(o => {
          if (o.data && notif.data.titre) {
            return o.data.titre === notif.data.titre
          }
        })
        // Si il y a déjà une notification non lu
        if (idxVisfound !== -1) {
          notif.count = state.notifications[idxVisfound].count + 1
        }
      }
      // console.log('idxVisfound', idxVisfound)
      // ajout de la notif
      if (idxVisfound === -1) {
        commit('ADD_NOTIF', notif)
      } else {
        notif.idxVisfound = idxVisfound
        commit('UPDATE_NOTIF', notif)
      }
      commit('SHOW')
    },

    /**
     * Ouvre la notification, autrement dit, envoie sur la route de l'action de la notif
     * petite exception pour les notification quota, il n'y a pas de route action sur le bouton
     */
    OPEN_NOTIF ({ commit, state, getters }, index) {
      // si il y a un router path pour cette notif
      if (state.notifications[index].action.path) {
        router.push({path: state.notifications[index].action.path})
        // mise à jour du focus agent
        this.commit('_StoreWatcheeBox/AGENT_FOCUS', {
          'titre': state.notifications[index].data.titre
        })
        commit('REMOVE_NOTIF', index)
      } else {
        // sinon c'est peut-etre une notification quota page ou c2c
        if (state.notifications[index].type === 'collections' || state.notifications[index].type === 'phone_in_talk') {
          window.open(state.notifications[index].data.url, 'souscription')
          commit('REMOVE_NOTIF', index)
        }
      }
    },

    /**
     * Cache la notification puis la supprime ou la marque comme 'vue'
     */
    HIDE_NOTIF ({ commit, state, getters }) {
      commit('HIDE')
      if (getters.index !== -1) {
        // si la notification pointée n'a pas de type,
        // alors elle n'est pas persistente
        if (_.isNil(state.notifications[getters.index].type)) {
          commit('REMOVE_NOTIF', getters.index)
        } else {
          // sinon, indique le fait qu'elle a été vue
          commit('VU', getters.index)
        }
        // Si d'autres notifs alors on réaffiche le toaster
        if (getters.index !== -1) {
          setTimeout(() => commit('SHOW'), 500)
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/notifier.js